/**
 * Construction progress for staff UI, customer portal, and project list sync.
 *
 * Counts every kelsa (phase) and workplan task on the project. N/A is treated as
 * complete (same as category/stage bars in ConstructionCategoryList).
 */

export interface ConstructionProgressSnapshot {
  percent: number;
  donePhases: number;
  totalPhases: number;
  doneTasks: number;
  totalTasks: number;
  doneUnits: number;
  totalUnits: number;
}

export function isKelsaDoneForProgress(status: string): boolean {
  return status === 'completed' || status === 'n_a';
}

export function isWorkTaskDoneForProgress(status: string): boolean {
  return status === 'done' || status === 'n_a';
}

export function computeConstructionProgress(
  phases: { status: string }[],
  tasks: { status: string }[] = [],
): ConstructionProgressSnapshot {
  const totalPhases = phases.length;
  const donePhases = phases.filter((p) => isKelsaDoneForProgress(p.status)).length;
  const totalTasks = tasks.length;
  const doneTasks = tasks.filter((t) => isWorkTaskDoneForProgress(t.status)).length;
  const totalUnits = totalPhases + totalTasks;
  const doneUnits = donePhases + doneTasks;
  const percent =
    totalUnits > 0 ? Math.min(Math.max(Math.round((doneUnits / totalUnits) * 100), 0), 100) : 0;

  return {
    percent,
    donePhases,
    totalPhases,
    doneTasks,
    totalTasks,
    doneUnits,
    totalUnits,
  };
}

/** @deprecated Prefer computeConstructionProgress; kept for existing call sites. */
export function constructionProgressPercentFromPhases(
  phases: { status: string }[],
  tasks: { status: string }[] = [],
): number {
  return computeConstructionProgress(phases, tasks).percent;
}
